import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from 'react-native';

// Cap the persisted ogInfo blob — without a bound it grows by one entry per
// unique URL for the lifetime of the install (parsed on every getOG call).
const OG_CACHE_MAX_ENTRIES = 200;

const getOG = async (url) => {
    // Caching the OG info so the previews load faster, does not cache the image, just the url and tags
    let storedOGInfo = await AsyncStorage.getItem("ogInfo");

    if(storedOGInfo){
        storedOGInfo = JSON.parse(storedOGInfo);

        if(storedOGInfo[url]){
            return storedOGInfo[url];
        }
    }

    // On web, fetch is blocked by CORS — route through a proxy
    const fetchUrl = Platform.OS === 'web'
        ? `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`
        : url;

    try {
        return await fetch(fetchUrl)
            .then((res) => res.text())
            .then(res => {
                const ogTags = res.match(/<meta[^<]*property="og:(.*?)".*?content="(.*?)"*>/g);

                const ogTagsFormatted = !ogTags || ogTags.length == 0 ? {} : ogTags.reduce((prev, m) => {
                    const contentMatches = m.match(/(?<=content=")([^"]*)/g)
                    const propertyMatches = m.match(/(?<=property=")([^"]*)/g)

                    if(propertyMatches.length > 0 && contentMatches.length > 0){
                        return {...prev, [propertyMatches[0]]: contentMatches[0] }
                    }
                }, {})

                const iconTags = res.match(/<link[^<]*rel=".*icon.*".*?href="(.*?)"*>/g);
                const icons = !iconTags || iconTags.length == 0 ? [] : iconTags.map(m => {
                    const contentMatches = m.match(/(?<=href=")([^"]*)/g)

                    return contentMatches.length > 0 ? contentMatches.find(i => ['.ico', '.png', '.svg'].some(e => i.toLowerCase().includes(e))) : ''
                })

                if(icons.length == 0){
                    const pathArray = url?.split( '/' );
                    const host = url?.toLowerCase().includes('http') ? pathArray[2] : pathArray[0];
                    icons.push('https://' + host + '/favicon.ico')
                }

                const nextOGInfo = {...(storedOGInfo || {}), [url]: {ogTags: ogTagsFormatted, icons, originalURL: url}}
                // Over the cap, drop the oldest entries — JSON object key
                // order is insertion order, so the first keys are the stalest.
                const keys = Object.keys(nextOGInfo)
                if(keys.length > OG_CACHE_MAX_ENTRIES){
                    keys.slice(0, keys.length - OG_CACHE_MAX_ENTRIES).forEach(k => delete nextOGInfo[k])
                }
                AsyncStorage.setItem("ogInfo", JSON.stringify(nextOGInfo))
                return {ogTags: ogTagsFormatted, icons, originalURL: url}
            });
    } catch(e) {
        return {ogTags: {}, icons: [], originalURL: url};
    }
}


const buildLinkPreview = (ogInfo) => {
    const usableIcons = ogInfo.icons?.map(i => {
        const pathArray = ogInfo.originalURL?.split( '/' );
        const host = ogInfo.originalURL?.toLowerCase().includes('http') ? pathArray[2] : pathArray[0];

        return !i.toLowerCase().startsWith("http") ? "https://" + host + i : i
    })

    const ogImage = {
        url: ogInfo?.ogTags?.["og:image"],
        width: ogInfo?.ogTags?.["og:image:width"] || 300,
        height: ogInfo?.ogTags?.["og:image:height"] || 300
    }
    const ogUrl = ogInfo?.ogTags?.["og:url"]
    const ogTitle = ogInfo?.ogTags?.["og:title"] || ogInfo?.ogTags?.["og:site_name"]
    const ogDesc = ogInfo?.ogTags?.["og:description"]

    return {ogImage, ogUrl, ogTitle, ogDesc, icon: usableIcons.length > 0 ? usableIcons[0] : null}
}

export {getOG, buildLinkPreview}